export default "__VITE_ASSET__DIPMUbT9__"